module.exports = __webpack_public_path__ + "assets/img/portfolio-hero.28d15441.webp";